module.exports = __webpack_public_path__ + "static/img/mazzo-di-carte-3.f4ba985.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mazzo-di-carte-3.svg
// module id = ZeY5
// module chunks = 1